import React, { FC } from 'react';

export interface NavigationalCaretRightProps {
  color: string;
  size?: number;
}

const NavigationalCaretRight: FC<NavigationalCaretRightProps> = ({
  color,
  size = 24,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M9 16L14 12L9 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NavigationalCaretRight;
